export default "/images/vendor/@coreui/icons/svg/flag/cif-bs.svg?dc0202038f7f2e1a2b73545814ce9175";